export default __webpack_public_path__ + "static/media/wPeople2.29ac51ec.png";